import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { paymentService } from "../services/paymentService";
import { useError } from "../context/ErrorContext";
import { useAuth } from "../context/AuthContext";
import PaymentForm from "../components/PaymentForm";

const Payment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showError } = useError();
  const { user } = useAuth();
  const [isProcessing, setIsProcessing] = useState(false);

  // Handle payment completion
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const billId = params.get("billplz[id]");
    const paid = params.get("billplz[paid]");

    if (billId) {
      verifyPayment(billId, paid === "true");
    }
  }, [location]);

  const verifyPayment = async (billId, isPaid) => {
    try {
      if (isPaid) {
        showError("Payment successful!", "success");
        navigate("/success");
      } else {
        showError("Payment failed. Please try again.");
        navigate("/failed");
      }
    } catch (error) {
      showError("Failed to verify payment");
    }
  };

  const handlePayment = async () => {
    try {
      setIsProcessing(true);
      await paymentService.createBill({
        email: user.email,
        name: user.name,
        amount: 1000, // Amount in cents (RM 10.00)
        description: "Premium subscription",
      });
    } catch (error) {
      showError("Failed to initiate payment");
      setIsProcessing(false);
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg p-4">
      <div className="max-w-md mx-auto">
        <PaymentForm
          amount={10.0}
          onSubmit={handlePayment}
          isProcessing={isProcessing}
        />
      </div>
    </div>
  );
};

export default Payment;
